import React, { useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Grid,
  Card,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const validLogins = [
  { Email: 'cheajeremy@gmail.com', Password: '123' },
];

const Login = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Email:', email, 'Password:', password);
    for (var details of validLogins) {
      if (details.Email === email && details.Password === password) {
        console.log('test');
        setIsLoggedIn(true);
        navigate('/dashboard');
        return;
      }
    }
  };

  return (
    <Container maxWidth="sm">
      <Card
        sx={{
          paddingTop: 3,
          paddingBottom: 3,
          marginTop: 20,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2, backgroundColor: '#f8b500' }}
          >
            Sign In
          </Button>
        </Box>
      </Card>
    </Container>
  );
};

export default Login;
